import { useContext } from 'react';
import { useTranslator } from '@jutro/locale';
import { CommunicationVariablesContext } from 'gw-capability-fnol-adac-react';
import messages from '../Service.messages';

const COMMUNICATION_TYPE_LABELS = {
    vehiclegermany: 'AdacKfzGermany',
    vehicleabroad: 'AdacKfzAbroad',
    medical: 'AdacMed'
};

export default function usePortalModeBasedLabel(key, params, commTypeExt) {
    let commTypeForMessage;

    if (commTypeExt !== undefined) {
        commTypeForMessage = commTypeExt;
    } else {
        const { communicationVariables } = useContext(CommunicationVariablesContext)
        const { communicationTypeExt } = communicationVariables;
        commTypeForMessage = communicationTypeExt;
    }
    
    const translator = useTranslator();
    const resultKey = key + (COMMUNICATION_TYPE_LABELS[commTypeForMessage] || 'AdacMed');
    return translator(messages[resultKey], params);
}
